<template>
	<v-container>
		<v-row class="contentRow"> 
			<v-col>
				<h1 class="text-left darkColor--text">Onsite Auditor Schedule</h1>
			</v-col>
			
			<!-- Show input form when NO existing data -->
			<v-col cols="12" v-if="!hasExistingData">
				<div class="contentRow" style="border: 5px solid #1e7c83">
					<v-col cols="12">
						<v-simple-table>
							<thead>
								<tr>
									<th class="text-left">Date</th>
									<th class="text-left">Time</th>
									<th class="text-left">Place</th>
									<th class="text-left">Examination</th>
									<th class="text-left">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(schedule, scheduleIndex) in schedules" :key="scheduleIndex">
									<td>
										<v-text-field dense outlined type="date" 
											v-model="schedule.date"
											label="Onsite Date" 
											hide-details 
											:min="new Date().toISOString().split('T')[0]"/>
									</td>
									<td>
										<v-text-field dense outlined type="time"
											v-model="schedule.time"
											placeholder="Enter time" 
											hide-details></v-text-field>
									</td>
									<td>
										<v-text-field dense outlined
											v-model="schedule.place"
											placeholder="Enter place" 
											hide-details></v-text-field>
									</td>
									<td>
										<v-text-field dense outlined
											v-model="schedule.examination"
											placeholder="Enter your examination" 
											hide-details></v-text-field>
									</td>
									<td>
										<v-btn icon color="red" @click="removeSchedules(scheduleIndex)">
											<v-icon small color="red">fas fa-times</v-icon>
										</v-btn>
									</td>
								</tr>
							</tbody>
						</v-simple-table>
						<v-btn color="primary" @click="addSchedules" class="ml-4 mt-5">
							Add More <v-icon right small>fas fa-plus</v-icon>
						</v-btn>
						<v-btn color="success" @click="submitSchedule" class="ml-5 mt-5">
							Send <v-icon right small>fas fa-paper-plane</v-icon>
						</v-btn>
					</v-col>
				</div>
			</v-col>
			
			<!-- Show read-only table when existing data is present -->
			<v-col cols="12" v-else>
				<div class="contentRow" style="border: 5px solid #4CAF50">
					<v-col cols="12">
						<v-simple-table>
							<thead>
								<tr>
									<th class="headers">Number</th>
									<th class="headers">Date</th>
									<th class="headers">Time</th>
									<th class="headers">Place</th>
									<th class="headers">Examination</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(schedule, scheduleIndex) in schedules" :key="scheduleIndex">
									<td><p>{{ scheduleIndex + 1 }}</p></td>
									<td><p>{{ formatDate(schedule.Date) }}</p></td>
									<td><p>{{ displayValue(schedule.Time) }}</p></td>
									<td><p>{{ displayValue(schedule.Place) }}</p></td>
									<td><p>{{ displayValue(schedule.Examination) }}</p></td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-col>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import LoadingState from "../../consts/LoadingState"
import AuditAPI from "../../api/audit/audit"
import { mapGetters } from "vuex"

export default {
	name: "ScheduleView",
	data() {
		return {
			schedules: [],
			hasExistingData: false,
		}
	},
	mounted() {
		const auditID = this.$route.params.id  
		this.loadSchedule(auditID)
	},
	computed: {
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		username() {
			return this.getUser.username
		},
	},
	methods: {
		displayValue(val) {
			return val === null || val === undefined || val === "" ? "-" : val
		},
		formatDate(timestamp) {
			return timestamp ? this.$moment(timestamp).format("YYYY-MM-DD") : "-"
		},
		addSchedules() {
			this.schedules.push({ date:"", time:"", place:"", examination:"" })
		},
		removeSchedules(index) {
			this.schedules.splice(index, 1)
		},
		submitSchedule() {
			const auditID = this.$route.params.id
			const scheduleItems = this.schedules.filter(schedule => 
				schedule.date || schedule.time || schedule.place || schedule.examination
			)
			
			if (scheduleItems.length === 0) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					"Please fill in at least one schedule entry",
					{ root: true }
				)
				return
			}
			
			AuditAPI.addAuditorSchedule(auditID, scheduleItems)
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully completed audit with ID '${data.auditID}'`,
						{ root: true }
					)
					this.loadSchedule(auditID)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadSchedule() {
			const auditID = this.$route.params.id
			AuditAPI.getSchedule(auditID)
				.then((result) => {
					if (Array.isArray(result) && result.length > 0) {
						this.schedules = result
						this.hasExistingData = true
					} else {
						this.schedules = [{ date:"", time:"", place:"", examination:"" }]
						this.hasExistingData = false
					}
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		}
	}
}
</script>

<style>
.contentRow .headers{
	font-size: 15px !important;
	color: #1e7c83 !important;
}
</style>